import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { SET_LAYOUT } from '@/store/mutations'
import { Message } from 'element-ui'
import homeRoutes from './home'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const LOGIN_ROUTE_NAME = 'Login'

const routes = [
  ...homeRoutes,
  {
    path: '/login',
    name: LOGIN_ROUTE_NAME,
    component: () => import('@/views/Login'),
    meta: {
      layout: 'Blank'
    }
  },
  // {
  //   path: '/',
  //   alais: '/dashboard',
  //   component: () => import('@/views/Dashboard')
  // },
  {
    path: '/dashboard',
    component: () => import('@/views/Dashboard')
  },
  {
    path: '/govDashboard',
    component: () => import('@/views/GovDashboard')
  },
  {
    path: '/orgDashboard',
    component: () => import('@/views/OrgDashboard')
  },
  {
    path: '/government',
    component: () => import('@/views/systems/Government/index')
  },
  {
    path: '/companies',
    component: () => import('@/views/systems/Companies/Index')
  },
  {
    path: '/user',
    component: () => import('@/views/systems/User')
  },
  {
    path: '/role',
    component: () => import('@/views/systems/Role')
  },
  {
    path: '/department',
    component: () => import('@/views/systems/Department')
  },
  {
    path: '/supplier',
    component: () => import('@/views/systemsConfig/Supplier')
  },
  {
    path: '/retailer',
    component: () => import('@/views/systemsConfig/Retailer')
  },
  {
    path: '/classes',
    component: () => import('@/views/systemsConfig/Classes')
  },
  {
    path: '/scheduling',
    component: () => import('@/views/systemsConfig/Scheduling')
  },
  {
    path: '/unitconfig',
    component: () => import('@/views/systemsConfig/Unitconfig')
  },
  {
    path: '/traceConfig',
    component: () => import('@/views/productConfig/TraceConfig/index')
  },
  {
    path: '/productManagement',
    component: () => import('@/views/productConfig/ProductManagement')
  },
  {
    path: '/materialManagement',
    component: () => import('@/views/tracing/MaterialManagement')
  },
  {
    path: '/productLogManagement',
    component: () => import('@/views/tracing/ProductLogManagement')
  },
  {
    path: '/batchManagement',
    component: () => import('@/views/tracing/BatchManagement')
  },
  {
    path: '/orderManagement',
    component: () => import('@/views/tracing/OrderManagement/index')
  },
  {
    path: '/statisticsDetail',
    component: () => import('@/views/statistic/StatisticsDetail')
  },
  {
    path: '/TraceDetail',
    component: () => import('@/views/statistic/TraceDetail')
  },
  {
    path: '/featureManagement',
    component: () => import('@/views/portal/FeatureManagement')
  },
  {
    path: '/slidesManagement',
    component: () => import('@/views/portal/SlidesManagement')
  },
  {
    path: '/BriefManagement',
    component: () => import('@/views/portal/BriefManagement')
  },
  {
    path: '/BannerManagement',
    component: () => import('@/views/portal/BannerManagement')
  },
  {
    path: '/NewsManagement',
    component: () => import('@/views/portal/NewsManagement')
  },
  {
    path: '/PolicyManagement',
    component: () => import('@/views/portal/PolicyManagement')
  },
  {
    path: '/ContentsManagement',
    component: () => import('@/views/portal/ContentsManagement')
  },
  {
    path: '/IndexConfig',
    component: () => import('@/views/portal/IndexConfig')
  },
  {
    path: '/operationLog',
    component: () => import('@/views/OperationLog')
  },
  {
    path: '/traceInquiry',
    component: () => import('@/views/traceInquiry/index'),
    meta: {
      layout: 'Blank'
    }
  },
  {
    path: '/c',
    component: () => import('@/views/c/index'),
    meta: {
      layout: 'Blank'
    }
  },
  {
    path: '/resource',
    component: () => import('@/views/systems/Resource')
  },
  {
    path: '/print',
    name: '/print',
    component: () => import('@/views/tracing/ProductLogManagement/components/Print'),
    meta: {
      layout: 'Blank'
    }
  }
]

const router = new VueRouter({
  routes
})

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // update layout
  store.commit(
    SET_LAYOUT,
    to.meta.layout ? `${to.meta.layout}Layout` : 'PrimaryLayout'
  )

  if (to.meta.noAuth) {
    next()
  } else {
    const { isLogin } = store.getters
    const isLoginRoute = to.name === LOGIN_ROUTE_NAME

    if (to.path === '/c') return next()
    if (to.path === '/traceInquiry') return next()

    if (!isLogin && !isLoginRoute) {
      Message({
        message: '未登录，请先登录！',
        type: 'error'
      })
      return next({ name: LOGIN_ROUTE_NAME })
    } else if (to.name === LOGIN_ROUTE_NAME && isLogin) {
      window.sessionStorage.setItem('activePath', '/dashboard')
      return next('/dashboard')
    } else {
      window.sessionStorage.setItem('activePath', '/dashboard')
      return next()
    }
  }
})

export default router
